export const RESET = 'EXCMTEAMUSERDATA_LIST_RESET'
export const SET_ITEMS = 'EXCMTEAMUSERDATA_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMTEAMUSERDATA_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMTEAMUSERDATA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMTEAMUSERDATA_LIST_TOGGLE_LOADING'
